<template>
  <!-- Table Container Card -->
  <b-card id="page-logs" no-body class="mb-0 p-2">
    <b-card-header
      class="pl-0 pr-0 d-flex align-items-between justify-content-start"
    >
      <b-col cols="12" sm="12" md="4" lg="4" xl="4">
        <b-card-title
          ><h2>{{ $t(label("title")) }}</h2></b-card-title
        >
      </b-col>
    </b-card-header>

    <Filterss
      :fields="fildsToFilters"
      :model="model"
      @filter-applied="applyFilters"
      @filter-reset="resetFilters"
    />

    <!-- Table for larger devices -->
    <b-table
      id="logs-table"
      responsive
      :head-variant="headVariant"
      :striped="striped"
      :bordered="bordered"
      :borderless="borderless"
      :outlined="outlined"
      :per-page="perPage"
      :busy="loading"
      :items="items"
      :fields="fields"
      class="d-none d-md-table shadow-sm !rounded"
    >
      <template #head()="data">
        <span class="text-black">{{
          $t(labelHeader(data.label.toLowerCase()))
        }}</span>
      </template>

      <template #cell(errorMessage)="data">
        <slot name="cell-errorMessage" :data="data">
          {{ data.item.errorMessage || "N/A" }}
        </slot>
      </template>

      <template #cell(source)="data">
        <slot name="cell-source" :data="data">
          {{ data.item.source || "N/A" }}
        </slot>
      </template>

      <template #cell(stackTrace)="data">
        <slot name="cell-stackTrace" :data="data">
          {{ "$" + data.item.stackTrace || "N/A" }}
        </slot>
      </template>

      <template #cell(timestamp)="data">
        <slot name="cell-timestamp" :data="data">
          {{ formatDateTime(data.item.timestamp) || "N/A" }}
        </slot>
      </template>

      <template #table-busy>
        <div class="text-center text-primary my-2">
          <b-spinner class="align-middle ml-50"></b-spinner>
          <strong>{{ $t("loading") }}...</strong>
        </div>
      </template>
    </b-table>

    <!-- Pagination -->
    <div class="mx-2 d-none d-md-table">
      <b-row>
        <b-col cols="12" md="2" class="mb-2">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">
              {{ $t("perPage") }}
            </label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              @change="handlePerPageChange"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="10"
          class="d-flex align-items-center justify-content-end"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            pills
            @change="handlePageChange"
            first-number
            last-number
          >
            <template #prev-text>
              <feather-icon size="18" icon="ChevronLeftIcon" />
            </template>
            <template #next-text>
              <feather-icon size="18" icon="ChevronRightIcon" />
            </template>
          </b-pagination>
        </b-col>
      </b-row>
    </div>

    <!-- List for mobile devices -->
    <div id="list-container" class="d-block d-md-none mt-1 list-container">
      <b-list-group>
        <b-list-group-item
          v-for="item in items"
          :key="item.guid"
          class="d-flex flex-column align-items-start border border-primary rounded mb-1"
        >
          <div class="d-flex w-100 justify-content-between mb-1">
            <strong> {{ item.errorMessage || "N/A" }}</strong>
          </div>
          <p class="m-0">
            <strong>{{ $t(labelHeader("stack_trace")) }}: </strong>
            {{ item.stackTrace || "N/A" }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("source")) }}: </strong>
            {{ item.source || "N/A" }}
          </p>
          <p class="m-0">
            <strong>{{ $t(labelHeader("timestamp")) }}: </strong
            >{{ formatDateTime(item.timestamp) || "N/A" }}
          </p>
        </b-list-group-item>
        <b-list-group-item v-if="items.length == 0" class="text-center">
          {{ $t("notRegister") }}
        </b-list-group-item>
        <b-list-group-item v-if="loading" class="text-center">
          <b-spinner class="align-middle ml-50" variant="primary"></b-spinner>
        </b-list-group-item>
      </b-list-group>
    </div>
  </b-card>
</template>
<script>
import _ from "lodash";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BButton,
  BTable,
  BTooltip,
  BSpinner,
  BFormSelect,
  BFormFile,
  BOverlay,
  BListGroup,
  BListGroupItem,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BRow,
} from "bootstrap-vue";
import Filterss from "../components/filters/Filterss.vue";
import { getLogs } from "@core/api/request/logs";
import { getParams, showLoading, stopLoading } from "@core/utils/utils";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCol,
    BButton,
    BTable,
    BTooltip,
    BSpinner,
    BFormSelect,
    BFormFile,
    BOverlay,
    BListGroup,
    BListGroupItem,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BRow,
    Filterss,
  },
  directives: {
    "b-tooltip": BTooltip,
  },
  data: () => ({
    model: "logs",
    loading: false,
    totalRows: 0,
    currentPage: 1,
    perPage: 10,
    pageOptions: [10, 50, 100],
    hasNextPage: true,
    items: [],
    headVariant: "light",
    striped: false,
    outlined: false,
    bordered: true,
    borderless: false,
    fields: [
      { label: "error_message", key: "errorMessage", sortable: true },
      { label: "stack_trace", key: "stackTrace", sortable: false },
      { label: "source", key: "source", sortable: false },
      { label: "timestamp", key: "timestamp", sortable: false },
    ],
    appliedFilters: {},
    fildsToFilters: [
      {
        name: "name",
        type: "text",
        placeholder: "name",
        type: "search",
        visible: true,
      },
    ],
  }),
  watch: {},
  created() {
    this.loadData();
  },
  mounted() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const listContainer = document.getElementById("list-container");
    if (listContainer) {
      listContainer.removeEventListener("scroll", this.handleScroll);
    }
  },
  methods: {
    async loadData() {
      showLoading();
      try {
        const params = this.chargeParams();
        const resp = await getLogs(params);

        const logs = _.get(resp, "data");
        this.items = logs?.items || [];
        this.totalRows = logs?.totalRows || 0;
        this.hasNextPage = logs?.currentPage < logs?.totalPages || 0;
      } catch (error) {
        console.error("API Error:", error);
        if (!silent)
          this.alertToast("danger", "Error", "No se pudo cargar el QR");
      } finally {
        stopLoading();
      }
    },

    loadLogsInfinity() {
      if (!this.hasNextPage) return;
      try {
        this.loading = true;
        const params = this.chargeParams();
        getLogs(params)
          .then((resp) => {
            const data = _.get(resp, "data", []);
            if (Array.isArray(data?.items)) {
              // Agregar nuevos elementos sin sobreescribir los existentes
              this.items = [...this.items, ...data?.items];
            }
            this.totalRows = data?.totalRows || 0;
            // Verificar si hay más páginas
            this.hasNextPage = data?.currentPage < data?.totalPages || false;
            this.loading = false;
          })
          .catch((error) => {
            this.alertToast(
              "danger",
              "Error",
              error.message,
              "AlertTriangleIcon",
            );
            console.error("Error loading products infinitely", error);
          });
      } catch (error) {
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
        console.error("Error cargando productos infinitamente", error.message);
      }
    },
    chargeParams() {
      const arrParams = [];
      arrParams.push(`page,${this.currentPage}`);
      arrParams.push(`rows,${this.perPage}`);

      // Aplicar filtros
      if (this.appliedFilters.name) {
        arrParams.push(`name,${this.appliedFilters.name}`);
      }

      return getParams(arrParams);
    },

    handleScroll() {
      const container = document.getElementById("list-container");
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight - 1
      ) {
        this.currentPage++;
        this.loadLogsInfinity();
      }
    },
    handlePageChange(value) {
      this.currentPage = value;
      this.hasNextPage = true;
      this.loadData();
    },
    handlePerPageChange() {
      this.loadData();
    },
    label(field) {
      return `pages.logs.table.${field}`;
    },
    labelHeader(field) {
      return `pages.logs.table.tableHeader.${field}`;
    },
    validateFilters(filters) {
      // Validar nombre (no debe ser vacío ni contener solo espacios)
      if (filters.name && !filters.name.trim()) {
        console.error("El filtro de nombre no es válido.");
        return false;
      }

      return true;
    },
    applyFilters(filters) {
      if (this.validateFilters(filters)) {
        this.appliedFilters = filters;
        this.currentPage = 1;
        this.hasNextPage = true;
        this.loadData();
      } else {
        console.error("Filtros no aplicados debido a validaciones fallidas.");
      }
    },
    resetFilters() {
      console.log("Resetting filters");
      this.appliedFilters = {};

      this.currentPage = 1;
      this.hasNextPage = true;
      this.loadData();
    },

    pad(n) {
      return String(n).padStart(2, "0");
    },

    formatDateTime(iso) {
      const d = new Date(iso);
      const dd = this.pad(d.getDate());
      const mm = this.pad(d.getMonth() + 1);
      const yyyy = d.getFullYear();
      const hh = this.pad(d.getHours());
      const min = this.pad(d.getMinutes());
      const ss = this.pad(d.getSeconds());
      return `${dd}/${mm}/${yyyy} ${hh}:${min}:${ss}`;
    },

    onInfo() {
      console.log("Displaying tutorial info");
    },
    message(title, text, icon, html) {
      this.$swal({
        title,
        text,
        html,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },
    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
.list-container {
  height: 60vh !important; /* Ajusta el alto según tus necesidades */
  overflow-y: auto;
}
.qr-code {
  border: 0px solid #ddd;
  padding: 10px;
  border-radius: 8px;
  margin: 20px auto;
}

.qr-placeholder {
  min-height: 320px;
  display: flex;
  align-items: center;
  justify-content: center;

  .alert {
    width: 100%;
    max-width: 300px;
    margin: 0 auto;
  }
}
</style>
